import React from 'react';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { IMAGES, scrollToBuy } from '../utils/constants';
export function Hero() {
  return <header className="w-full bg-white" data-id="element-123" data-mp="ei1zbx8twn38">
      <div className="mx-auto flex max-w-4xl flex-col items-center px-3 pb-3 pt-4 text-center sm:px-5 sm:pt-5" data-id="element-124" data-mp="9lv1krql6hwd">
        <span className="font-head text-[10px] uppercase tracking-[0.14em] text-blue sm:text-xs" data-id="element-125" data-mp="4n1jem0cu2pv">
          The Complete Visual Learning System For Kids
        </span>

        <h1 className="mt-1 font-head text-[28px] uppercase leading-[0.94] text-navy sm:text-5xl lg:text-6xl" data-id="element-126" data-mp="x9usbrnwe8ay">
          Make learning easier.{' '}
          <span className="italic text-green" data-id="element-127" data-mp="s9gic42qkoaa">Have it ready.</span>
        </h1>

        <p className="mt-1.5 max-w-2xl text-[13px] leading-snug text-muted sm:text-base" data-id="element-128" data-mp="nbey3ftkqix8">
          Visual learning resources for reading, math, science, language, geography and everyday
          skills — organized in one complete system.
        </p>

        <p className="mt-1 text-[10px] font-bold uppercase tracking-wide text-navy sm:text-xs" data-id="element-129" data-mp="3j8sd1u7lx7mo">
          Parents · Teachers · Tutors · Homeschoolers
        </p>

        <button type="button" onClick={scrollToBuy} className="mt-2 block w-full max-w-2xl transition-opacity duration-150 ease-out hover:opacity-95" aria-label="Go to the purchase section" data-id="element-130" data-mp="3o6u71a6kmrcx">
          <img src={IMAGES.boxSet} alt="Kids Learning Ready complete visual learning system shown as printable cards, box, desktop, tablet and phone" className="mx-auto w-full" loading="eager" data-id="element-131" data-mp="3e7uzxw1gf3s1" />
        </button>

        <div className="-mt-1 flex w-full flex-col items-center" data-id="element-132" data-mp="35aucpsq4fbq6">
          <CtaButton data-id="element-133" data-mp="2qkwmz8cjmdyv" />
          <TrustRow className="mt-1.5" data-id="element-134" data-mp="2qlogmdmky1mi" />
        </div>
      </div>
    </header>;
}